var map = {
	"./bon-achat.svg": 3639,
	"./cadeaux_collectors/affiche-circuit.png": 5286,
	"./cadeaux_collectors/affiche-depart.png": 4189,
	"./cadeaux_collectors/magnet-1923.jpg": 5436,
	"./cadeaux_collectors/magnet-1954.jpg": 878,
	"./cadeaux_collectors/magnet-1958.jpg": 6626,
	"./cadeaux_collectors/magnet-1959.jpg": 2943,
	"./cadeaux_collectors/magnet-1960.jpg": 3119,
	"./cadeaux_collectors/magnet-1961.jpg": 738,
	"./cadeaux_collectors/magnet-1963.jpg": 9504,
	"./cadeaux_collectors/magnet-1967.jpg": 8180,
	"./goodies/casquette.png": 8283,
	"./goodies/goodies.png": 8468,
	"./goodies/porte-cle.png": 9579,
	"./goodies/sac-cordon.png": 4181,
	"./super_cadeaux/casque.png": 9111,
	"./super_cadeaux/porte-monnaie.png": 6695,
	"./super_cadeaux/sac-cuir.png": 2080,
	"./super_cadeaux/tv.png": 875
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1912;